"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRouter = void 0;
const core_1 = require("@ts-rest/core");
const auth_1 = require("./auth");
const collections_1 = require("./collections");
const discount_1 = require("./discount");
const orders_1 = require("./orders");
const payments_1 = require("./payments");
const products_1 = require("./products");
const shipping_rates_1 = require("./shipping-rates");
const stores_1 = require("./stores");
const users_1 = require("./users");
const c = (0, core_1.initContract)();
exports.AdminRouter = c.router({
    auth: auth_1.AuthRouter,
    collections: collections_1.CollectionsRouter,
    discount: discount_1.DiscountRouter,
    orders: orders_1.OrdersRouter,
    payments: payments_1.PaymentsRouter,
    products: products_1.ProductsRouter,
    shippingRates: shipping_rates_1.ShippingRatesRouter,
    stores: stores_1.StoresRouter,
    users: users_1.UsersRouter,
}, { pathPrefix: '/admin' });
